import { IMenuItem } from '../../models/menu.model';
import { setupMenu } from './setup.menu';

const _superAdminMenu: IMenuItem[] = [ 
  {
    label: 'Account Reconciliations',
    path: 'account-recon',
    icon: 'fa fa-calculator',
  },
  {
    label: 'Candidates',
    path: 'candidates',
    icon: 'fa fa-user-plus',
  },
  {
    label: 'Agents',
    path: 'agents',
    icon: 'fa fa-id-badge',
  },
  {
    label: 'Agent Staging',
    path: 'agent-staging',
    icon: 'fa fa-hourglass-half',
  },
  {
    label: 'Recalculate Agent License Expiry',
    path: 'patch-license',
    icon: 'fa fa-history',
  },
  {
    label: 'Batch Operations',
    path: 'batch',
    icon: 'fa fa-tasks',
  },
  {
    label: `Batch Candidate Update`,
    path: 'batch-candidate-update',
    icon: 'fa fa-upload',
  },
  {
    label: `Batch Company Payment Update`,
    path: 'batch-company-payment-update',
    icon: 'fa fa-credit-card',
  },
  {
    label: `Agent Staging Migration`,
    path: 'agent-staging-migration',
    icon: 'fa fa-exchange',
  },
];

export const superAdminMenu: IMenuItem[] = [
  setupMenu,
  ..._superAdminMenu.map((x) => ({ ...x, path: '/super/' + x.path })),
];
